import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalleriesComponent } from './galleries/galleries.component';
import { GalleriesOpenComponent } from './galleries-open/galleries-open.component';
import { IonicModule } from '@ionic/angular';
import { GeneralesComponentsModule } from '../generales-components/generales-components.module';
import { SliderGaleriesComponent } from '../components/slider-galeries/slider-galeries.component';
import { ComponentsCompraModule } from '../pages/vista-compra/components-compra/components-compra.module';
import { ProductsComponentModule } from '../products-component/products-component.module';
import { DetailedGalleryComponent } from '../components/detailed-gallery/detailed-gallery.component';
import { FeaturedGalleryComponent } from '../components/featured-gallery/featured-gallery.component';
import { PipeModule } from '../pipes/pipe-module.module';
import { TranslateModule } from '@ngx-translate/core';
import { ShowTitlePipe } from './pipes/show-title.pipe';
import { ComponentsSliderModule } from '../components/slider-galeries/components/components.module';
import { DirectivesModule } from '../directives/directives.module';
import { ResponsiveImagesPipe } from './pipes/responsive-images.pipe';
import { SliderGaleriesImagesComponent } from '../components/slider-galeries-images/slider-galeries-images.component';
import { ComponentsSliderTwoModule } from '../components/slider-galeries-images/components/components-two.module';

const declarations = [
  GalleriesComponent,
  GalleriesOpenComponent,
  SliderGaleriesComponent,
  SliderGaleriesImagesComponent,
  DetailedGalleryComponent,
  FeaturedGalleryComponent,
  ShowTitlePipe,
  ResponsiveImagesPipe,
];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    GeneralesComponentsModule,
    ComponentsCompraModule,
    DirectivesModule,
    ProductsComponentModule,
    PipeModule,
    TranslateModule,
    ComponentsSliderModule,
    ComponentsSliderTwoModule,
  ],
  exports: declarations,
})
export class GalleryComponentsModule {}
